const RATE_PERIODS = {
    villa: [
        { from: "2025-11-01", to: "2026-04-30", rates: { single: 190, double: 170, noTreatmentSingle: 90, noTreatmentDouble: 75 } },
        { from: "2026-05-01", to: "2026-10-31", rates: { single: 135, double: 125, noTreatmentSingle: 85, noTreatmentDouble: 70 } },
        { from: "2026-11-01", to: "2027-04-30", rates: { single: 195, double: 175, noTreatmentSingle: 95, noTreatmentDouble: 80 } },
        { from: "2027-05-01", to: "2027-10-31", rates: { single: 140, double: 130, noTreatmentSingle: 90, noTreatmentDouble: 75 } },
    ],
    om: [],
    mudra: [],
    aadya: [
        { from: "2025-11-01", to: "2026-04-30", rates: { single: 175, double: 155, noTreatmentSingle: 75, noTreatmentDouble: 60 } },
        { from: "2026-05-01", to: "2026-10-31", rates: { single: 120, double: 110, noTreatmentSingle: 70, noTreatmentDouble: 55 } },
        { from: "2026-11-01", to: "2027-04-30", rates: { single: 185, double: 165, noTreatmentSingle: 85, noTreatmentDouble: 70 } },
        { from: "2027-05-01", to: "2027-10-31", rates: { single: 130, double: 120, noTreatmentSingle: 80, noTreatmentDouble: 65 } },
    ],
};
RATE_PERIODS.om = RATE_PERIODS.villa;
RATE_PERIODS.mudra = RATE_PERIODS.villa;
export const RESORTS = [
    { id: "villa", name: "Hiru Villa", japanName: "ヒルヴィラ", roomTypes: ["double", "junior-suite", "master-suite"] },
    { id: "om", name: "Hiru Om", japanName: "ヒルオーム", roomTypes: ["double"] },
    { id: "mudra", name: "Hiru Mudra", japanName: "ヒルムッドラ", roomTypes: ["double"] },
    { id: "aadya", name: "Hiru Aadya", japanName: "ヒルアーディヤ", roomTypes: ["double"] },
];
export const ROOMS_CATALOG = [
    // Hiru Villa - ダブルルーム
    {
        id: 1,
        resortId: "villa",
        type: "double",
        name: "ダブルルーム",
        category: "ダブルルーム",
        description: "コロニアル様式の趣と現代的な心地よさが調和した、ヒルヴィラの中心となるお部屋です。海を眺めながら穏やかな時間をお過ごしいただけます。",
        image: "/images/Hiru/Hiru Villa's/Room/AH2I3011-Edit-copy.webp",
        size: "32㎡",
        occupancy: 2,
        services: [
            { icon: "Maximize", text: "専用バルコニーまたはテラス" },
            { icon: "Bed", text: "ダブルベッド" },
            { icon: "Droplets", text: "シャワールーム" },
            { icon: "Wind", text: "エアコン・シーリングファン" },
            { icon: "Wifi", text: "無料Wi-Fi" },
            { icon: "Sparkles", text: "蚊帳" },
        ],
        seasonRates: {
            summer: { single: 135, double: 125 },
            winter: { single: 195, double: 175 },
        },
    },
    // Hiru Villa - ジュニアスイート
    {
        id: 2,
        resortId: "villa",
        type: "junior-suite",
        name: "ジュニアスイート",
        category: "ジュニアスイート",
        description: "より広々とした滞在を楽しみたい方のための、落ち着きと上質さを備えた特別なお部屋です。",
        image: "/images/Hiru/Hiru Villa's/Junior Suite/680A1902-Edit-copy.webp",
        size: "50㎡",
        occupancy: 2,
        services: [
            { icon: "Maximize", text: "海を感じる専用テラス" },
            { icon: "Bed", text: "ゆったりとしたベッドスペース" },
            { icon: "Droplets", text: "シャワールーム" },
            { icon: "Wind", text: "エアコン・シーリングファン" },
            { icon: "Wifi", text: "無料Wi-Fi" },
            { icon: "Sparkles", text: "蚊帳" },
        ],
        seasonRates: {
            summer: { single: 155, double: 145 },
            winter: { single: 215, double: 195 },
        },
    },
    // Hiru Villa - マスタースイート
    {
        id: 3,
        resortId: "villa",
        type: "master-suite",
        name: "マスタースイート",
        category: "マスタースイート",
        description: "ヒルヴィラで最も贅沢なひとときをお過ごしいただける、特別な一室です。",
        image: "/images/Hiru/Hiru Villa's/Master Suite/680A2236-Edit-copy.webp",
        size: "70㎡",
        occupancy: 2,
        services: [
            { icon: "Maximize", text: "美しい景色を楽しむテラス" },
            { icon: "Bed", text: "ゆとりあるベッドスペース" },
            { icon: "Droplets", text: "シャワールーム" },
            { icon: "Wind", text: "エアコン・シーリングファン" },
            { icon: "Wifi", text: "無料Wi-Fi" },
            { icon: "Sparkles", text: "蚊帳" },
        ],
        seasonRates: {
            summer: { single: 180, double: 165 },
            winter: { single: 240, double: 220 },
        },
    },
    // Hiru Om - ダブルルーム
    {
        id: 4,
        resortId: "om",
        type: "double",
        name: "ダブルルーム",
        category: "ダブルルーム",
        description: "約38平米のゆとりある広さ。専用のバルコニーから美しい庭園やインド洋の穏やかな海を見渡すことができます。",
        image: "/images/OM Edited/DSC03211.webp",
        size: "38㎡",
        occupancy: 2,
        services: [
            { icon: "Maximize", text: "専用バルコニー" },
            { icon: "Bed", text: "ダブルベッド" },
            { icon: "Droplets", text: "シャワー・トイレ" },
            { icon: "Wind", text: "エアコン・シーリングファン" },
            { icon: "Wifi", text: "無料Wi-Fi" },
            { icon: "Sparkles", text: "蚊帳" },
        ],
        seasonRates: {
            summer: { single: 135, double: 125 },
            winter: { single: 195, double: 175 },
        },
    },
    // Hiru Mudra - ダブルルーム
    {
        id: 5,
        resortId: "mudra",
        type: "double",
        name: "ダブルルーム",
        category: "ダブルルーム",
        description: "約34平米のゆったりとした室内。すべてのお部屋が海に面しており、専用のバルコニーから波の呼吸をすぐそばに感じることができます。",
        image: "/images/Mudra Edited/DSC02016.webp",
        size: "34㎡",
        occupancy: 2,
        services: [
            { icon: "Maximize", text: "海に面した専用バルコニー" },
            { icon: "Bed", text: "ダブルベッド" },
            { icon: "Droplets", text: "シャワー・トイレ" },
            { icon: "Wind", text: "エアコン・シーリングファン" },
            { icon: "Wifi", text: "無料Wi-Fi" },
            { icon: "Sparkles", text: "蚊帳" },
        ],
        seasonRates: {
            summer: { single: 135, double: 125 },
            winter: { single: 195, double: 175 },
        },
    },
    // Hiru Aadya - ダブルルーム
    {
        id: 6,
        resortId: "aadya",
        type: "double",
        name: "ダブルルーム",
        category: "ダブルルーム",
        description: "全室オーシャンビュー。約38平米の広々とした室内は、スタイリッシュな家具で整えられた、モダンで心地よい空間です。",
        image: "/images/Finalized photos/Edited/DSC01386.webp",
        size: "38㎡",
        occupancy: 2,
        services: [
            { icon: "Maximize", text: "海を望むバルコニーまたはテラス" },
            { icon: "Bed", text: "ダブルベッド" },
            { icon: "Droplets", text: "シャワー・トイレ" },
            { icon: "Wind", text: "エアコン・シーリングファン" },
            { icon: "Wifi", text: "無料Wi-Fi" },
            { icon: "Sparkles", text: "蚊帳" },
        ],
        seasonRates: {
            summer: { single: 120, double: 110 },
            winter: { single: 185, double: 165 },
        },
    },
];
export const isSummerSeason = (date) => {
    const month = date.getMonth();
    return month >= 4 && month <= 9;
};
export const getRatesForDate = (resortId, date) => {
    const dateKey = [date.getFullYear(), date.getMonth() + 1, date.getDate()]
        .map((part) => String(part).padStart(2, "0"))
        .join("-");
    const periods = RATE_PERIODS[resortId];
    const period = periods.find(({ from, to }) => dateKey >= from && dateKey <= to);
    if (period) {
        return period.rates;
    }
    return dateKey < periods[0].from ? periods[0].rates : periods[periods.length - 1].rates;
};
export const getResortById = (id) => RESORTS.find(r => r.id === id);
export const getResortName = (id) => getResortById(id)?.japanName || "";
export const getRoomTypesByResort = (resortId) => getResortById(resortId)?.roomTypes || [];
export const getDisplayNameForRoomType = (roomType) => {
    const typeNames = {
        "double": "ダブルルーム",
        "junior-suite": "ジュニアスイート",
        "master-suite": "マスタースイート",
    };
    return typeNames[roomType];
};
